import React from "react";
import WhatWeOffer from "../components/WhatWeOffer";
import Reveal from "../components/Reveal";
import understatedLogo from "../assets/design/understated-logo.svg";
import designDcv from "../assets/design/design-dcv.jpg";

const Services = () => {
  return (
    <div className="bg-ink pt-28 lg:pt-32">
      {/* Hero */}
      <section className="relative overflow-hidden px-6 pt-16 pb-20 text-center">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_40%,rgba(91,62,255,0.16)_0%,transparent_70%)]" />
        <div className="pointer-events-none absolute inset-0 hero-grid" />

        <div className="relative z-10 max-w-4xl mx-auto">
          <p className="eyebrow mb-6 fade-up" style={{ animationDelay: "0.2s" }}>
            Services
          </p>
          <h1
            className="font-display text-[clamp(56px,10vw,120px)] leading-[0.92] tracking-wide text-paper fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            Prototype to <span className="text-brand-cyan">store</span>
          </h1>
          <p
            className="mt-7 mx-auto max-w-xl text-muted text-[17px] leading-relaxed fade-up"
            style={{ animationDelay: "0.55s" }}
          >
            End-to-end product design and engineering, from first prototype to
            the store listing.
          </p>
        </div>
      </section>

      <WhatWeOffer />

      {/* Design partner — logo and artwork used with Understated's permission */}
      <section className="border-t border-ink-line bg-ink-soft px-6 sm:px-12 lg:px-20 py-28">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-14 md:gap-20 items-center">
          <Reveal>
            <p className="eyebrow mb-6">Design partner</p>

            {/* their wordmark is white, so it sits on a dark chip */}
            <div className="inline-flex items-center bg-ink-card border border-ink-line rounded-xl px-5 py-3.5 mb-8">
              <img
                src={understatedLogo}
                alt="Understated"
                className="h-7 w-auto"
              />
            </div>

            <h2 className="display-title mb-6">
              We build. Understated makes it look effortless.
            </h2>
            <div className="w-20 h-[3px] rounded-full bg-brand-grad mb-8" />

            <p className="text-body text-muted mb-5">
              We work with{" "}
              <a
                href="https://understated.me/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-brand-cyan hover:underline"
              >
                Understated
              </a>{" "}
              on brand and interface design — including ReFleks, HepB &amp; Me
              and FalorAI.
            </p>
            <p className="text-body text-muted mb-9">
              They designed our own identity too. That mark on the right is
              theirs — and so is the one at the top of this page.
            </p>

            <a
              href="https://understated.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
            >
              Visit Understated
            </a>
          </Reveal>

          <Reveal delay={120}>
            <img
              src={designDcv}
              alt="Deep-C Vision brand design by Understated"
              loading="lazy"
              className="w-full rounded-tile border border-ink-line shadow-card"
            />
            <p className="mt-5 text-center font-mono text-[10px] tracking-[0.18em] text-muted">
              DEEP-C VISION BRAND DESIGN BY UNDERSTATED
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Services;
